'use client';

/**
 * Breadcrumb.tsx — wrapper rundt @carbon/react Breadcrumb
 *
 * Beholder vår eksisterende API (items-array med valgfri href)
 * men bruker Carbon Breadcrumb + BreadcrumbItem internt.
 * href utelatt = current page (isCurrentPage=true).
 *
 * Bruk:
 *   <Breadcrumb items={[{ label: 'Jobs', href: '/jobs' }, { label: 'Job #123' }]} />
 */

import { Breadcrumb as CarbonBreadcrumb, BreadcrumbItem } from '@carbon/react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  ariaLabel?: string;
}

export default function Breadcrumb({ items, ariaLabel = 'Breadcrumb' }: BreadcrumbProps) {
  return (
    <CarbonBreadcrumb aria-label={ariaLabel} size="sm">
      {items.map((item) => (
        <BreadcrumbItem
          key={item.href ?? item.label}
          href={item.href}
          isCurrentPage={!item.href}
        >
          {item.label}
        </BreadcrumbItem>
      ))}
    </CarbonBreadcrumb>
  );
}